import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "asset-notification-history-wrapper" }
const _hoisted_2 = { class: "notification-history-container" }
const _hoisted_3 = { class: "row mb-4" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "dashboard-title" }
const _hoisted_6 = { class: "message-cell" }
const _hoisted_7 = { class: "message-content" }
const _hoisted_8 = { class: "asset-cell" }
const _hoisted_9 = { class: "asset-badge" }
const _hoisted_10 = { class: "sent-at-cell" }
const _hoisted_11 = { class: "date-time" }
const _hoisted_12 = { class: "recipient-cell" }
const _hoisted_13 = { class: "groups-cell" }
const _hoisted_14 = { class: "channels-cell" }
const _hoisted_15 = { class: "channel-icons" }
const _hoisted_16 = ["title"]
const _hoisted_17 = ["title"]
const _hoisted_18 = ["title"]
const _hoisted_19 = { class: "status-cell" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxHeaderFilter = _resolveComponent("DxHeaderFilter")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxPager = _resolveComponent("DxPager")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h3", _hoisted_5, [
            _cache[0] || (_cache[0] = _createElementVNode("i", { class: "bi bi-bell-fill" }, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('components.assetNotificationHistory.title')), 1)
          ])
        ])
      ]),
      _createVNode(_component_DxDataGrid, {
        ref: _ctx.gridRef,
        "data-source": _ctx.store,
        "hover-state-enabled": true,
        "remote-operations": true,
        "column-auto-width": false,
        "show-borders": true,
        scrolling: _ctx.scrollingConfig,
        "column-hiding-enabled": true,
        "word-wrap-enabled": true,
        onOptionChanged: _ctx.detectFilters
      }, {
        "message-template": _withCtx(({ data }) => [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.formatMessage(data.data.message)), 1)
          ])
        ]),
        "asset-template": _withCtx(({ data }) => [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _cache[1] || (_cache[1] = _createElementVNode("i", { class: "bi bi-broadcast-pin" }, null, -1)),
              _createElementVNode("span", null, _toDisplayString(_ctx.getAssetLabel(data.data.message, data.data.asset)), 1)
            ])
          ])
        ]),
        "sent-at-template": _withCtx(({ data }) => [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.formatDateTime(data.data.sent_at)), 1)
          ])
        ]),
        "recipient-template": _withCtx(({ data }) => [
          _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.getRecipientName(data.data.user)), 1)
        ]),
        "groups-template": _withCtx(({ data }) => [
          _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.getRecipientGroups(data.data.user)), 1)
        ]),
        "channels-template": _withCtx(({ data }) => [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              (data.data.is_sent_by_email)
                ? (_openBlock(), _createElementBlock("i", {
                    key: 0,
                    class: "bi bi-envelope-fill channel-icon email-icon",
                    title: _ctx.getEmailTooltip(data.data.email)
                  }, null, 8, _hoisted_16))
                : _createCommentVNode("", true),
              (data.data.is_sent_by_sms)
                ? (_openBlock(), _createElementBlock("i", {
                    key: 1,
                    class: "bi bi-phone-fill channel-icon sms-icon",
                    title: _ctx.getPhoneTooltip(data.data.phone_number)
                  }, null, 8, _hoisted_17))
                : _createCommentVNode("", true),
              (data.data.is_sent_by_mercure)
                ? (_openBlock(), _createElementBlock("i", {
                    key: 2,
                    class: "bi bi-broadcast channel-icon mercure-icon",
                    title: _ctx.getMercureTooltip()
                  }, null, 8, _hoisted_18))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        "status-template": _withCtx(({ data }) => [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", {
              class: _normalizeClass(["status-badge", data.data.is_read ? 'read' : 'unread'])
            }, [
              _createElementVNode("i", {
                class: _normalizeClass(data.data.is_read ? 'bi bi-check-circle-fill' : 'bi bi-circle-fill')
              }, null, 2)
            ], 2)
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_DxHeaderFilter, { visible: true }),
          _createVNode(_component_DxFilterRow, { visible: true }),
          _createVNode(_component_DxPaging, { "page-size": 20 }),
          _createVNode(_component_DxPager, {
            "allowed-page-sizes": [10, 20, 50, 100],
            "show-info": true,
            "show-navigation-buttons": true,
            "show-page-size-selector": true,
            visible: true
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "message",
            caption: _ctx.$t('components.assetNotificationHistory.message'),
            "cell-template": "message-template",
            "min-width": _ctx.isMobile ? 200 : 300,
            "hiding-priority": 3
          }, null, 8, ["caption", "min-width"]),
          _createVNode(_component_DxColumn, {
            "data-field": "asset.name",
            caption: _ctx.$t('components.assetNotificationHistory.asset'),
            "cell-template": "asset-template",
            "min-width": _ctx.isMobile ? 150 : 200,
            "hiding-priority": 1
          }, null, 8, ["caption", "min-width"]),
          _createVNode(_component_DxColumn, {
            "data-field": "user.name",
            caption: _ctx.$t('components.assetNotificationHistory.recipient'),
            "cell-template": "recipient-template",
            "calculate-filter-expression": _ctx.recipientFilterExpression,
            "min-width": _ctx.isMobile ? 160 : 220,
            "hiding-priority": 2
          }, null, 8, ["caption", "calculate-filter-expression", "min-width"]),
          _createVNode(_component_DxColumn, {
            "data-field": "user.assetGroups",
            caption: _ctx.$t('components.assetNotificationHistory.groups'),
            "cell-template": "groups-template",
            "calculate-filter-expression": _ctx.groupsFilterExpression,
            "min-width": _ctx.isMobile ? 180 : 260,
            "hiding-priority": 3
          }, null, 8, ["caption", "calculate-filter-expression", "min-width"]),
          _createVNode(_component_DxColumn, {
            "data-field": "sent_at",
            caption: _ctx.$t('components.assetNotificationHistory.sentAt'),
            "cell-template": "sent-at-template",
            alignment: "center",
            width: _ctx.isMobile ? 120 : 180,
            "allow-filtering": false,
            "hiding-priority": 0
          }, null, 8, ["caption", "width"]),
          _createVNode(_component_DxColumn, {
            caption: _ctx.$t('components.assetNotificationHistory.channels'),
            "cell-template": "channels-template",
            width: _ctx.isMobile ? 100 : 150,
            "allow-filtering": false,
            alignment: "center",
            "hiding-priority": 0
          }, null, 8, ["caption", "width"]),
          _createVNode(_component_DxColumn, {
            caption: _ctx.$t('components.assetNotificationHistory.status'),
            "cell-template": "status-template",
            width: _ctx.isMobile ? 80 : 120,
            "allow-filtering": false,
            alignment: "center",
            "hiding-priority": 4
          }, null, 8, ["caption", "width"])
        ]),
        _: 1
      }, 8, ["data-source", "scrolling", "onOptionChanged"])
    ])
  ]))
}